import { BaseModel } from '/@/modules/core/app/models/abstracts/BaseModel';

export class GoogleAddressComponent extends BaseModel {
  /**
   * @var {string}
   */
  longName;

  /**
   * @var {string}
   */
  shortName;

  /**
   * @var {array}
   */
  types;

  constructor(model = {}) {
    super();
    /**
     * @var {string} long_name
     */
    this.longName = model.long_name;
    /**
     * @var {string} short_name
     */
    this.shortName = model.short_name;
    this.types = model.types;
  }
}
